import React, { useState } from "react";
import {  collection, addDoc } from "firebase/firestore";
import { db } from '../AppointmentComp/firebase';
import './footer.css';



function FooterComp() {


    const [firstName, setFirstName] = useState("");
    const [email, setEmail] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
  
    const handleSubscribe = async () => {
      if (!firstName || !email) {
        setAlertMessage("Please fill in all fields!");
        return;
      }
  
      try {
        await addDoc(collection(db, "subscriptions"), {
          firstName,
          email,
          subscribedAt: new Date(),
        });
        setAlertMessage("You have been successfully subscribed!");
        setFirstName(""); // Clear input fields
        setEmail("");
      } catch (error) {
        console.error("Error adding document: ", error);
        setAlertMessage("Something went wrong. Please try again.");
      }
    };





  return (
    <div>     <footer className="footer">
    <div className="footer-section">
      {/* Connect With Us Section */}
      <div className="footer-column">
        <h3>Connect With Us</h3>
        <div className="footer-links-container">
          <a
            href="https://web.facebook.com/profile.php?id=100064081658719"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook"></i> Facebook
          </a>
          <a
            href="https://www.instagram.com/eyecarelk?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
          <i className="fab fa-instagram"></i> Instagram
          </a>
          <a
            href="https://www.tiktok.com/@eyecarelk?_t=ZS-8tGljgcGB20&_r=1"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-tiktok"></i> TikTok
          </a>
          <a
            href="mailto:eyecareoptical2024@gmail.com"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-envelope"></i> eyeclinicandoptical@gmail.com
          </a>
        </div>
      </div>


      {/* Information Section */}
      <div className="footer-column">
        <h3>Information</h3>
        <div class="footer-links-container">
        <a href="/faqs" className="footer-link">
          FAQs
        </a>
        <a href="/termsandconditions" className="footer-link">
          Terms & Conditions
        </a>
        <a href="/privacyandpolicies" className="footer-link">
          Privacy & Policies
        </a>
        <a href="/refundpolicy" className="footer-link">
        Refund Policy
        </a>
       
        </div>
      </div>

      {/* Categories Section */}
      <div className="footer-column">
        <h3>Categories</h3>
        <div class="footer-links-container">
        <a href="/sunglasses" className="footer-link">
          Sunglasses
        </a>
        <a href="/spectacles" className="footer-link">
          Spectacles
        </a>
        <a href="/lens" className="footer-link">
          Lenses
        </a>
        <a href="/contactlens" className="footer-link">
          Contact Lenses
        </a>
        <a href="/accessories" className="footer-link">
          Accessories
        </a>
        </div>
      </div>

          <div className="footer-column">
          <div className="footer-links-container">
            <h3>News & Letter</h3>
            <p>Subscribe to stay updated with our latest offers and news.</p>
            <input
              type="text"
              placeholder="First Name"
              className="footer-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email Address"
              className="footer-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className="footer-button" onClick={handleSubscribe}>
              Subscribe
            </button>
            {alertMessage && <p className="alert-message">{alertMessage}</p>}
          </div>



    </div>
        {/* Payment method */}
        <div className="footer-column">
          <h3>We are accepted</h3>
          <div className="payment-method-images">
            <img src="visacard.png" alt="Visa" className="payment-method-img" />
            <img src="mastercard.png" alt="Mastercard" className="payment-method-img" />
          </div>
        </div>

    </div>
        <div style={{ textAlign: "center" }}>
            {/* White Line with 80% Width */}
            <hr style={{ border: "1px solid white", width: "80%", margin: "10px auto" }} />
            
            {/* Copyright Text */}
            <p style={{ marginTop: "20px", color: "white" }}>
              &copy; 2025 Eye Care Clinic & Optical. All rights reserved.
            </p>
          </div>

  </footer></div>
  )
}

export default FooterComp